import { Box, CircularProgress, Skeleton, styled } from '@mui/material'
import React from 'react'

function LoadingSkeleton(props) {
  return (
    <Box width={"100%"} height={"100%"} position={"relative"}>
      <Skeleton {...props} color={"secondary"} />

      <LoadingBox>
        <CircularProgress size={24} color='secondary' />
      </LoadingBox>
    </Box>
  )
}

const LoadingBox = styled(Box)(() => ({
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%) !important",
  display: "flex",
}))

export default LoadingSkeleton